import React, { useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { IAccount } from '../../../models/company-account';
import { IOrderDetails, IOrderUpdateShipTo } from '../../../models/order';
import DropShipModal from './modals/drop-ship-modal';
import PriorAddressModal from './modals/prior-address-modal';
interface IShippingDropdownProps {
    order: IOrderDetails | null;
    shipToAccounts: IAccount[];
}
export const ShippingDropdown = ({
    order,
    shipToAccounts,
}: IShippingDropdownProps) => {
    const intl = useIntl();
    const [updatedShipTo, setUpdatedShipTo] = useState<IOrderUpdateShipTo>({
        orderNumber: order!.orderNumber,
        shipToAccount: '',
    });
    const [priorAddressModal, setPriorAddressModal] = useState(false);
    const [selected, setSelected] = useState('option_1');
    const [dropShipModal, setDropShipModal] = useState(false);
    const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value);
        if (e.target.value === 'add_address') {
            setDropShipModal(true);
            return;
        }
        if (e.target.value === 'option_1') {
            return;
        }
        const account = shipToAccounts.find(
            (account) => account.fullAccountNumber === e.target.value
        ) as IAccount;
        setUpdatedShipTo({
            ...updatedShipTo,
            shipToAccount: account.fullAccountNumber,
        });
        setPriorAddressModal(true);
    };
    return (
        <>
            {shipToAccounts && (
                <>
                    <select
                        className="form-control search-all-option"
                        onChange={onChange}
                        value={selected}
                    >
                        <option value="option_1" disabled hidden>
                            &#xf002;
                            {' ' +
                                intl.formatMessage({
                                    id: 'Search_all_addresses',
                                    defaultMessage: 'Search all addresses',
                                })}
                        </option>
                        {shipToAccounts.map((option, i) => (
                            <option key={i} value={option.fullAccountNumber}>
                                {option.fullAccountNumber +
                                    ': ' +
                                    option.fullAddress}
                            </option>
                        ))}
                        <option
                            key={'add_address'}
                            value={'add_address'}
                            className="add-address-option"
                        >
                            +
                            {' ' +
                                intl.formatMessage({
                                    id: 'Add_Address',
                                    defaultMessage: 'Add Address',
                                })}
                        </option>
                    </select>

                    {dropShipModal && (
                        <DropShipModal
                            onAccept={() => undefined}
                            onClose={() => {
                                setDropShipModal(false);
                            }}
                        />
                    )}
                    {priorAddressModal && (
                        <PriorAddressModal
                            updatedShipTo={updatedShipTo}
                            onAccept={() => undefined}
                            onClose={() => {
                                setPriorAddressModal(false);
                            }}
                        />
                    )}
                </>
            )}
        </>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        updateShipTo: state.updateShipTo ? state.updateShipTo.data : null,
        order: state.order ? state.order.data! : null,
        selected: state.select,
    };
};

const mapDispatchToProps = {};

const shippingDropdownContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShippingDropdown);

export default shippingDropdownContainer;
